
import * as api from "../constant/NewAPI";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import Select from "react-select";
import * as XLSX from "xlsx";
import { all_routes } from "../router/all_routes";
import Utils from "../constant/Utils";

// import * as api from "../constant/API";

const attendanceReport = () => {

    const routes = all_routes;

    const userId = localStorage.getItem('UserId');
    const roleId = localStorage.getItem('RoleId');

    const [searchInput, setSearchInput] = useState('');
    const [instituteList, setInstituteList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [attendanceList, setAttendanceList] = useState([]);
    const [coachList, setCoachList] = useState([]);
    const [batchList, setBatchList] = useState([]);
    const [detailsList, setDetailsList] = useState([]);
    const [groupId, setGroupId] = useState('');
    const [institutionId, setInstitutionId] = useState('');
    const [coachId, setCoachId] = useState('All');
    const [batchId, setBatchId] = useState('All');
    const [fromDate, setFromDate] = useState('All');
    const [searchQuery, setSearchQuery] = useState('');
    const [toDate, setToDate] = useState('All');
    const [showTable, setShowTable] = useState(false);
    const [linkClicked, setLinkClicked] = useState(false);

    useEffect(() => {
        instituteTypeList()
    }, [])

    function instituteTypeList() {
        const instTypeList = api.InstituteTypeList + '/' + roleId //+ "?userId=" + userId + "&roleId=" + roleId;
        fetch(instTypeList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((typResponse) => typResponse.json())
            .then((typResult) => {
                if (typResult.error == true) {
                    if (typResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (typResult.data != null) {
                        setGroupList(typResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log('Failed to fetch Institute Type List', error);
            })
    }

    function getInstitutes(grpId) {
        const institute = api.GetReportInstitutions + '/' + roleId + '/' + grpId //+ "?institutionTypeId=" + grpId + "&userId=" + userId + "&roleId=" + roleId;
        fetch(institute, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((instReponse) => instReponse.json())
            .then((instResult) => {
                if (instResult.error == true) {
                    if (instResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (instResult.data != null) {
                        setInstituteList(instResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch institution list", error)
            })
    }

    function getCoachList(insid) {
        const cochlst = api.GetCoachList + '/' + roleId + '/' + insid //+ "?InstituteId=" + insid + "&role=" + roleId + "&userId=" + userId;
        fetch(cochlst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((cochResponse) => cochResponse.json())
            .then((cochResult) => {
                if (cochResult.error == true) {
                    if (cochResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (cochResult.data != null) {
                        setCoachList(cochResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch coach list", error)
            })
    }

    function getBatchList(cochid) {
        let getbtchlst = api.GetRprtBatchList + '/' + institutionId //+ "?coachId=" + cochid + "&Institute=" + institutionId;
        if (roleId != 6) {
            getbtchlst += '/' + cochid
        }
        fetch(getbtchlst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((btchResponse) => btchResponse.json())
            .then((btchResult) => {
                if (btchResult.error == true) {
                    if (btchResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (btchResult.data != null) {
                        setBatchList(btchResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch batch list.", error)
            })
    }

    function atndcReport() {
        const atendncReport = api.GetAttendanceReport + '/' + groupId + '/' + coachId + '/' + batchId + '/' + fromDate + '/' + toDate + '/' + institutionId //"?insType=" + groupId + "&Institute=" + institutionId + "&coach=" + coachId + "&batch=" + batchId + "&fromDate=" + fromDate + "&tillDate=" + toDate;
        fetch(atendncReport, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((statResponse) => statResponse.json())
            .then((statResult) => {
                if (statResult.error == true) {
                    if (statResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (statResult.data != null) {
                        setAttendanceList(statResult.data);
                    }
                    setShowTable(true)
                    setLinkClicked(true)
                }
            })
            .catch((error) => {
                console.log('Failed to fetch status report.', error)
            })
    }

    function showDetails(itm) {
        const scdlId = itm.attendanceScheduleId;
        const rprtAtndc = api.GetReportAttendanceDetails + '/' + scdlId + '/' + institutionId //"?ScheduleId=" + scdlId + "&Institute=" + institutionId;
        fetch(rprtAtndc, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((rprtResponse) => rprtResponse.json())
            .then((rprtResult) => {
                if (rprtResult.error == true) {
                    if (rprtResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (rprtResult.data != null) {
                        setDetailsList(rprtResult.data);
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch details list", error)
            })
    }

    function exportnow() {
        const formData = new FormData();
        formData.append("institutionType", groupId);
        formData.append("institutionId", institutionId);
        formData.append("coach", coachId);
        formData.append("batch", batchId);
        formData.append("fromDate", fromDate);
        formData.append("tillDate", toDate);
        const exprt = api.AttendanceReportExport;
        fetch(exprt, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData,
        })
            .then((exprtResponse) => exprtResponse.json())
            .then((exprtResult) => {
                if (exprtResult.error == true) {
                    if (exprtResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    // exportToExcel(exprtResult)
                    const blob = new Blob([exprtResult.data], { type: "application/vnd.ms-excel" });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "Attendance Report.xls"; // Save file as .xls
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }
            })
            .catch((error) => {
                console.log("Failed to fetch attendance report", error);
            })
    }

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const filteredData = attendanceList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const filteredAttendance = detailsList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchQuery.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const batchRender = (rowData, column) => {
        return <span>{rowData.batchName}</span>
    };

    const scheduleRender = (rowData, column) => {
        return <span>{formatDate(rowData.scheduleDate)}</span>;
    };

    const timeRender = (rowData, column) => {
        return <span>{rowData.timeduration}</span>
    };

    const skillRender = (rowData, column) => {
        return <span>{rowData.SkillName}</span>;
    };

    const detailsRender = (rowData) => {
        return (
            <Link to="#" data-bs-toggle="modal" data-bs-target="#attendance-list" onClick={() => { showDetails(rowData); }}>
                <i className="feather feather-eye"></i>View
            </Link>
        );
    };

    function exportToExcel(htmlString) {
        // Create a new workbook and worksheet
        const workbook = XLSX.utils.book_new();

        // Create a DOM parser to parse the HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        // Extract the table from the HTML
        const table = doc.querySelector('table');

        if (table) {
            // Convert the HTML table to a worksheet
            const worksheet = XLSX.utils.table_to_sheet(table);

            // Prepare to insert the title
            const title = "Attendance Report";
            const colCount = Object.keys(worksheet).filter(cell => cell.match(/^[A-Z]+1$/)).length;

            // Shift existing data down by one row
            const dataRange = XLSX.utils.decode_range(worksheet['!ref']);
            for (let R = dataRange.e.r; R >= dataRange.s.r; R--) {
                for (let C = dataRange.s.c; C <= dataRange.e.c; C++) {
                    const oldCell = XLSX.utils.encode_cell({ r: R, c: C });
                    const newCell = XLSX.utils.encode_cell({ r: R + 1, c: C });
                    if (worksheet[oldCell]) {
                        worksheet[newCell] = worksheet[oldCell];
                        delete worksheet[oldCell];
                    }
                }
            }

            // Set the title in the first row
            worksheet['A1'] = { t: 's', v: title };
            worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: colCount - 1 } }];
            worksheet['A1'].s = {
                font: { sz: 18, bold: true },
                alignment: { horizontal: 'center', vertical: 'center' },
                border: {
                    top: { style: 'thin', color: { rgb: '000000' } },
                    bottom: { style: 'thin', color: { rgb: '000000' } },
                    left: { style: 'thin', color: { rgb: '000000' } },
                    right: { style: 'thin', color: { rgb: '000000' } },
                }
            };

            // Apply formatting to header cells
            const headerRow = 1; // Header row index (1-based)
            for (let C = dataRange.s.c; C <= dataRange.e.c; C++) {
                const headerCell = XLSX.utils.encode_cell({ r: headerRow, c: C });
                if (worksheet[headerCell]) {
                    worksheet[headerCell].s = {
                        font: { bold: true },
                        border: {
                            top: { style: 'thin', color: { rgb: '000000' } },
                            bottom: { style: 'thin', color: { rgb: '000000' } },
                            left: { style: 'thin', color: { rgb: '000000' } },
                            right: { style: 'thin', color: { rgb: '000000' } },
                        }
                    };
                }
            }

            // Add borders to all other cells
            for (let row = 1; row <= dataRange.e.r; row++) {
                for (const col in worksheet) {
                    if (col.match(/^[A-Z]+\d+$/)) {
                        const cellRef = col;
                        if (worksheet[cellRef] && !worksheet[cellRef].s) {
                            worksheet[cellRef].s = {
                                border: {
                                    top: { style: 'thin', color: { rgb: '000000' } },
                                    bottom: { style: 'thin', color: { rgb: '000000' } },
                                    left: { style: 'thin', color: { rgb: '000000' } },
                                    right: { style: 'thin', color: { rgb: '000000' } },
                                }
                            };
                        }
                    }
                }
            }

            // Adjust the row height for the title
            worksheet['!rows'] = [{ hpx: 30 }, ...Array.from({ length: dataRange.e.r - dataRange.s.r + 1 }, () => ({}))];

            // Adjust column widths
            const colWidths = XLSX.utils.sheet_to_json(worksheet, { header: 1 }).reduce((widths, row) => {
                return row.map((value, i) => {
                    const width = value ? value.toString().length : 10; // 10 is a default minimum width
                    return Math.max(widths[i] || 10, width);
                });
            }, []);

            worksheet['!cols'] = colWidths.map(w => ({ wch: w + 1 })); // Adding some padding

            // Add the worksheet to the workbook
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Attendance Report');

            // Generate Excel file and trigger download
            XLSX.writeFile(workbook, 'AttendanceReport.xlsx');
        } else {
            console.error('Table not found in the HTML string.');
        }
    }

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">
                                    <i className="fa fa-university"></i>
                                    Attendance Report
                                </h3>
                            </div>
                            <div>
                                <Link
                                    to={routes.reports}
                                    className="btn btn-primary save-profile"
                                >
                                    <i className="fas fa-arrow-left"></i>Back
                                </Link>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="court-tab-content">
                                        <div className="court-tab-content">
                                            <div className="card card-tableset">
                                                <div className="card-body">
                                                    <div className="coache-head-blk">
                                                        <div className="row align-items-center">
                                                            <div className="row col-md-12">
                                                                <div className="row col-md-12 court-sortby sortbyset">
                                                                    <div className="col-lg-3 mb-10">
                                                                        <label className="sortbytitle"><h6>Institute Group</h6></label>
                                                                        <Select
                                                                            value={groupList.find(grp => grp.institutionGroupId === groupId) ? {
                                                                                value: groupId,
                                                                                label: groupList.find(grp => grp.institutionGroupId === groupId).institutionGroupName
                                                                            } : null}
                                                                            onChange={(e) => {
                                                                                setGroupId(e.value);
                                                                                getInstitutes(e.value)
                                                                            }}
                                                                            options={groupList.map(grp => ({
                                                                                value: grp.institutionGroupId,
                                                                                label: grp.institutionGroupName
                                                                            }))}>
                                                                        </Select>
                                                                    </div>
                                                                    <div className="col-lg-3 mb-10">
                                                                        <label className="sortbytitle"><h6>Institute</h6></label>
                                                                        <Select value={instituteList.find(inst => inst.institutionId === institutionId) ? {
                                                                            value: institutionId,
                                                                            label: instituteList.find(inst => inst.institutionId === institutionId).institutionName
                                                                        } : null}
                                                                            onChange={(e) => {
                                                                                setInstitutionId(e.value)
                                                                                getCoachList(e.value)
                                                                            }}
                                                                            options={instituteList.map(inst => ({
                                                                                value: inst.institutionId,
                                                                                label: inst.institutionName
                                                                            }))}
                                                                            placeholder={"Select Institute"}
                                                                        />
                                                                    </div>
                                                                    <div className="col-lg-3 mb-10">
                                                                        <label className="sortbytitle"><h6>Coach</h6></label>
                                                                        <Select value={coachList.find(coch => coch.icsCoach === coachId) ? {
                                                                            value: coachId,
                                                                            label: coachList.find(coch => coch.icsCoach === coachId).CoachName
                                                                        } : null}
                                                                            onChange={(e) => {
                                                                                setCoachId(e.value)
                                                                                getBatchList(e.value)
                                                                            }}
                                                                            options={coachList.map(coch => ({
                                                                                value: coch.icsCoach,
                                                                                label: coch.CoachName
                                                                            }))}
                                                                            placeholder={"Select Coach"}
                                                                        />
                                                                    </div>
                                                                    <div className="col-lg-3 mb-10">
                                                                        <label className="sortbytitle"><h6>Batch</h6></label>
                                                                        <Select value={batchList.find(btch => btch.batchId === batchId) ? {
                                                                            value: batchId,
                                                                            label: batchList.find(btch => btch.batchId === batchId).batchName
                                                                        } : null}
                                                                            onChange={(e) => {
                                                                                setBatchId(e.value)
                                                                            }}
                                                                            options={batchList.map(btch => ({
                                                                                value: btch.batchId,
                                                                                label: btch.batchName
                                                                            }))}
                                                                            placeholder={"Select Batch"}
                                                                        />
                                                                    </div>
                                                                    <div className="col-lg-3 mb-10">
                                                                        <label className="sortbytitle"><h6>From Date</h6></label>
                                                                        <input className="col-md-12" type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={fromDate} onChange={(e) => setFromDate(e.target.value)}></input>
                                                                    </div>
                                                                    <div className="col-lg-3 mb-10">
                                                                        <label className="sortbytitle"><h6>To Date</h6></label>
                                                                        <input className="col-md-12" type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={toDate} onChange={(e) => setToDate(e.target.value)}></input>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <div className="save-changes text-sm mt-4">
                                                                            <Link
                                                                                to="#"
                                                                                className="btn btn-primary save-profile"
                                                                                onClick={atndcReport}
                                                                            >
                                                                                Submit
                                                                            </Link>
                                                                            <Link
                                                                                to="#"
                                                                                className={`btn btn-secondary save-profile`}
                                                                                // onClick={exportToExcel}
                                                                                onClick={exportnow}
                                                                            >
                                                                                Export to Excel
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12 border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                                    {showTable && (
                                                                        <>
                                                                            <div className="col-md-12">
                                                                            </div>
                                                                            <div className="col-md-12">
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <div className="dataTables_filter">
                                                                                    <label>
                                                                                        <input
                                                                                            type="text"
                                                                                            value={searchInput}
                                                                                            onChange={(e) => setSearchInput(e.target.value)}
                                                                                            placeholder="Search"
                                                                                            className="form-control"
                                                                                        />
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {showTable && (
                                                                <>
                                                                    <div className="tab-content">
                                                                        <div
                                                                            className="tab-pane fade show active"
                                                                            id="nav-Recent"
                                                                            role="tabpanel"
                                                                            aria-labelledby="nav-Recent-tab"
                                                                            tabIndex={0}
                                                                        >
                                                                            <div className="table-responsive table-datatble">
                                                                                <DataTable
                                                                                    className="table datatable"
                                                                                    value={filteredData}
                                                                                    paginator
                                                                                    rows={10}
                                                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                                                    // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                                    pageLinkSize={3}
                                                                                >
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="slNo"
                                                                                        body={slNoRender}
                                                                                        header="Sl No"
                                                                                    // headerStyle={{ backgroundColor: "#0f2a4e", color: "#FFFF" }}
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="scheduleDate"
                                                                                        body={scheduleRender}
                                                                                        header="Schedule Date"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="timeduration"
                                                                                        body={timeRender}
                                                                                        header="Time Duration"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="SkillName"
                                                                                        body={skillRender}
                                                                                        header="Skill"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        body={detailsRender}
                                                                                    ></Column>
                                                                                </DataTable>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            {/* Batch Attendance List */}

            <div
                className="modal custom-modal fade request-modal"
                id="attendance-list"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header modal-header-title">
                                <h4 className="mb-0">
                                    Attendance Details
                                </h4>
                            </div>
                            <Link
                                to="#"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="align-center" aria-hidden="true">
                                    <i className="feather-x" />
                                </span>
                            </Link>
                        </div>
                        <div className="modal-body">
                            <div className="row text-sm-end">
                                <div className="dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            placeholder="Search Students"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="table-responsive table-datatble">
                                    <table className="table datatable">
                                        <thead className="thead-light">
                                            <tr>
                                                <th className="text-uppercase">Sl No.</th>
                                                <th className="text-uppercase">Student Name</th>
                                                <th className="text-uppercase">Class</th>
                                                <th className="text-uppercase">Section</th>
                                                <th className="text-uppercase">Gender</th>
                                                <th className="text-uppercase">Attendance</th>
                                                <th className="text-uppercase">Attendance Comment</th>
                                            </tr>
                                            {Array.isArray(filteredAttendance) && filteredAttendance.map((atndc, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{atndc.StudentName}</td>
                                                    <td>{atndc.class}</td>
                                                    <td>{atndc.section}</td>
                                                    <td>{atndc.coreUserGender}</td>
                                                    <td>{atndc.attendanceName}</td>
                                                    <td>{atndc.Comments}</td>
                                                </tr>
                                            ))}
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Batch Attendance List */}
        </>
    )
};

export default attendanceReport;